   
import initNECaptchaWithFallback from '@/utils/yidun.js';
   //易盾滑动验证弹框
 function  yidunPopup(callback) {
      let that = this;
      var captchaIns = null;
      initNECaptchaWithFallback;
      initNECaptchaWithFallback({
          captchaId: '9dccfc4c48d848eeab699c32920e8867',
          element: '#captcha',
          mode: 'popup',
          width: '320px',
          onVerify: function (err, data) {
            callback(err, data)
              // if (err) {
              //     that.NECaptchaValidate = null;
              //     return false;
              // }
              // that.NECaptchaValidate = data.validate;
              // //获取验证码，滑动的
              // that.falg=true;
              // clearTimeout(down);
              // that.getCodeState = false;
              // that.codeTime = 60;
              // that.countDownStart();

          }
      }, function onload(instance) {
          captchaIns = instance;
          captchaIns && captchaIns.popUp();
      }, function onerror(err) {
          // 初始化失败后触发该函数，err对象描述当前错误信息
          console.log(err)
      })

  }
  export default yidunPopup